import { z } from 'zod/v4';

export const SenderDTO = z.object({
  id: z.string(),
  name: z.string(),
  active: z.boolean(),
  config: z.string(),
  sender_type: z.enum(['EMAIL', 'TELEGRAM']),
});

export const SenderItemDTO = SenderDTO.pick({
  id: true,
  name: true,
});

export type Sender = z.infer<typeof SenderDTO>;
export type SenderItem = z.infer<typeof SenderItemDTO>;